import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"right","font-size":".9rem","margin":".8rem 1rem 0 0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/about" }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("ForkStyleについて")
      ])),
      _: 1
    })
  ]))
}